import React from "react";
import styled from "styled-components";
import ButtonIcon from './ButtonIcon'
import { FaGithub } from "react-icons/fa";
import { IoRocket } from "react-icons/io5";
import { useAnalytics } from '../context/AnalyticsContext';

const Card = styled.div`
  color: #ccc;
  width: 100%;
  max-width: 420px;
  height: 256px;
  border: 1px solid #333;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 20px;
  position: relative;
  &:hover{
    border-color: var(--color-brand-900);
  }
`;

const Title = styled.h2`
  color: #eee;
  font-size: 1.8rem;
  margin-bottom: 10px;
`;

const Description = styled.p`
  flex: 1;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5; 
  margin-bottom: 5px;
  text-align: justify;
  word-wrap: normal;
  overflow-y: hidden;
  text-overflow: ellipsis;
`;

const ChipContainer = styled.div`
  /* width: 80%; */
  margin-bottom: auto;
  display: flex;
  flex-wrap: wrap;
  position: absolute;
  top: 168px;
  left: 20px; 
  right: 20px;
`;

const Chip = styled.div`
  font-size: 1.2rem;
  text-transform: lowercase;
  background-color: #333;
  color: #abc;
  padding: 0px 5px;
  border-radius: 5px;
  margin-right: 5px;
  margin-bottom: 5px;
  display: flex;
`;

const CardFooter = styled.div`
  /* margin-top: auto; */
  /* margin-left: auto; */
  display: flex;
  align-items: center;
  justify-content: flex-end;
  position: absolute;
  bottom: 10px;
  right: 10px; 
  left: auto; 
`;

const RepoContainer = styled.div`
  display: inline-flex;
  align-items: baseline;
  justify-content: right;
  /* width: 20%; */
`;
const StyledButton = styled.a`
  display: inline-flex;
  align-items: center;
  text-decoration: none;
  padding: 6px 12px;
  border: 2px solid transparent;
  border-radius: 4px;
  font-size: 16px;
  color: #aaa;
  background-color: transparent;
  cursor: pointer;
  transition: all 0.1s ease-in-out;
  &:hover {
    color: ${props => props.hcolor ? props.hcolor : '#3730a3'};
  }
  &:focus{
    outline: none;
  }
  & + & {
    margin-left: 10px; // Adjust spacing between buttons if needed
  }
`;
// const RepoIcon = styled.img`
//   width: 20px;
//   height: 20px;
//   margin-right: 5px;
// `;

// const DeploymentBadge = styled.img`
//   width: 100px;
//   height: 20px;
// `;

const ProjectCard = ({ title, description, repoUrl, deployedUrl, technologies }) => {
  const { trackTabClick } = useAnalytics();

  return (
    <Card>
      <Title>{title}</Title>
      <Description>{description}</Description>
      <ChipContainer>
        {technologies?.map((tech, index) => (
          <Chip key={index}>{tech}</Chip>
        ))}
      </ChipContainer>
      <CardFooter>
        <RepoContainer>
         {deployedUrl && <StyledButton
            href={deployedUrl}
            target='_blank'
            rel='noopener noreferrer'
            onClick={()=>trackTabClick(`deployment: ${deployedUrl}`)}
          >
            <IoRocket />
            &nbsp; Deployment
          </StyledButton>}
          <StyledButton
            href={repoUrl}
            target='_blank'
            rel='noopener noreferrer'
            onClick={()=>trackTabClick(`deployment: ${repoUrl}`)}
          >
            {/* <RepoIcon src="/github-icon.svg" alt="GitHub Repo" /> */}
            <FaGithub />
            &nbsp; GitHub
          </StyledButton>

          {/* {deploymentStatus && <DeploymentBadge src="https://img.shields.io/badge/in%20progress-yellow" alt="Deployment Status" />} */}
        </RepoContainer>
      </CardFooter>
    </Card>
  );
};

export default ProjectCard;
